"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardType = void 0;
var CreditCardType;
(function (CreditCardType) {
    CreditCardType["visa"] = "Visa";
    CreditCardType["masterCard"] = "MasterCard";
    CreditCardType["americanExpress"] = "American Express";
    CreditCardType["discover"] = "Discover";
    CreditCardType["unknown"] = "Unknown";
})(CreditCardType = exports.CreditCardType || (exports.CreditCardType = {}));
//# sourceMappingURL=creditCardType.js.map